import { combineReducers } from '@reduxjs/toolkit'

import { photosReducer } from './features/photos/model/photosSlice'
import { productOperationsReducer } from './features/products/model/operationsSlice'
import { productsReducer } from './features/products/model/productsSlice'

import { importReducer } from './features/import/model/importSlice'
import { pricingReducer } from './features/pricing/model/pricingSlice'
import { suppliesReducer } from './features/supplies/model/suppliesSlice'

import { inventoryReducer } from './features/inventory/model/inventorySlice'
import { warehouseChoiceReducer } from './features/inventory/model/warehouseChoiceSlice'
import { priceTagScanReducer, priceTagsReducer } from './features/price-tags/model/priceTagsSlice'
import { cashReceiptsReducer } from './features/receipts/model/receiptsSlice'
import { cashShiftsReducer } from './features/shifts/model/shiftsSlice'
import { structureReducer } from './features/structure/model/structureSlice'
import { createDefaultsReducer } from './features/create-defaults/model/createDefaultsSlice'

/**
 * Состояние модуля `onec`: только намерения фич (поиск, черновики, выбор
 * кадра) и идентичность пишущих команд. Ответы службы 1С в состояние модуля
 * не кладутся — они в кэше RTK Query (R01).
 */
export const onecUiReducer = combineReducers({
  products: productsReducer,
  productOperations: productOperationsReducer,
  photos: photosReducer,
  pricing: pricingReducer,
  importFlow: importReducer,
  supplies: suppliesReducer,
  inventory: inventoryReducer,
  inventoryWarehouse: warehouseChoiceReducer,
  priceTags: priceTagsReducer,
  priceTagScan: priceTagScanReducer,
  structure: structureReducer,
  receipts: cashReceiptsReducer,
  shifts: cashShiftsReducer,
  createDefaults: createDefaultsReducer,
})

export type OneCUiState = ReturnType<typeof onecUiReducer>
